<template>
  <tr :key="id">
    <td class="col-2">{{ number }}</td>
    <td class="col-2">{{ model }}</td>
    <td class="col-2">{{ serie }}</td>
    <td class="col-5">{{ linkedDocument.docKey }}</td>
    <td class="col-1">
      <a
        href="javascript:"
        @click="removeLinkedDocumentCollection(id)"
        class="remove-linkedDocument text-muted"
      >
        <Close title="Excluir" />
      </a>
    </td>
  </tr>
</template>

<script>
import Close from 'vue-material-design-icons/Close';
import { mapState } from 'vuex';
import { MODELO } from '../../../../../../Fiscal/enums/Documento';

export default {
  name: 'LinkedDocument',
  components: {
    Close,
  },
  props: ['linkedDocument', 'id'],
  computed: {
    ...mapState('purchase', ['linkedDocuments']),
    model() {
      return this.linkedDocument.docKey.substr(20, 2);
    },
    serie() {
      if (this.model === MODELO.SAT) return '';
      return this.linkedDocument.docKey.substr(22, 3);
    },
    number() {
      if (this.model === MODELO.SAT) return this.linkedDocument.docKey.substr(31, 6);
      return this.linkedDocument.docKey.substr(25, 9);
    },
  },
  methods: {
    async removeLinkedDocumentCollection(id) {
      this.linkedDocuments.linkedDocumentCollection.splice(id, 1);
    },
  },
};
</script>
